<template>
  <div class="add">
    <button class="button button--border add__button" @click.prevent="$emit('add')">
      <slot />
    </button>
  </div>
</template>

<script>
export default {
  name: 'SettingsAdd'
}
</script>

<style lang="scss" scoped>
.add {
  display: flex;
  justify-content: center;
}
</style>
